import api from '@/utils/http'

const BASE_PATH = '/v4/tracking-databoard'

function ensureSuccess(response, fallbackMessage) {
  if (!response || response.code !== 200 || response.success === false) {
    throw new Error(response?.message || response?.errorMsg || fallbackMessage)
  }
  return response.data
}

export async function fetchProjectList(params = {}) {
  const data = await api.post(`${BASE_PATH}/api/project/pageQuery`, {
    name: params.name || '',
    page: params.page || 1,
    size: params.size || 50,
    sortField: params.sortField || 'id',
    sortOrder: params.sortOrder || 'desc'
  })
  return ensureSuccess(data, '获取项目列表失败')
}

export async function fetchChannelList(params) {
  const data = await api.post(`${BASE_PATH}/api/module/custom/channelList`, params)
  return ensureSuccess(data, '获取渠道列表失败')
}

export async function fetchBasicMain(params) {
  const data = await api.post(`${BASE_PATH}/api/module/basic/main`, params)
  return ensureSuccess(data, '获取流量主数据失败')
}

export async function fetchBehaviorList(params) {
  const data = await api.post(`${BASE_PATH}/api/module/custom/behaviorList`, {
    channel: '',
    indexName: '',
    ...params
  })
  return ensureSuccess(data, '获取行为数据失败')
}

export async function fetchBehaviorDetail(params) {
  const data = await api.post(`${BASE_PATH}/api/module/custom/main`, params)
  return ensureSuccess(data, '获取行为按天数据失败')
}
